// import axios from 'axios'

export default {
  guardarUsuario ({ commit }, payload) {
    localStorage.setItem('token', payload)
    commit('obtenerUsuario', payload)
  },
}
